<h1 mat-dialog-title>
    App Log Data
    <mat-icon (click)="onCancel()" style="float: right;">close</mat-icon>
</h1>
<div mat-dialog-content>
    <mat-list class="mat-list-overflow">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.id ?? 'N/A'}}</span>
                    <span matListItemLine>Log ID</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.created_at | date: 'dd/MM/yyyy hh:mm a'}}</span>
                    <span matListItemLine>Date &amp; Time Created At</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.level ?? 'N/A'}}</span>
                    <span matListItemLine>Level</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.module ?? 'N/A'}}</span>
                    <span matListItemLine>Module</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.action ?? 'N/A'}}</span>
                    <span matListItemLine>Action</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.status_code ?? 'N/A'}}</span>
                    <span matListItemLine>Status Code</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.duration_ms ?? 'N/A'}}</span>
                    <span matListItemLine>Duration (ms)</span>
                </mat-list-item>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-list-item class="border-bottom-solid">
                    <span matListItemTitle>{{appLogDetails?.user_name ?? 'N/A'}}</span>
                    <span matListItemLine>User</span>
                </mat-list-item>
            </div>

            <!-- Message -->
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="log-field-block border-bottom-solid">
                    <div class="log-field-content">{{appLogDetails?.message ?? 'N/A'}}</div>
                    <div class="log-field-label">Message</div>
                </div>
            </div>

            <!-- Error Trace -->
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="log-field-block border-bottom-solid">
                    <div class="log-field-content log-field-mono">{{appLogDetails?.error_trace ?? 'N/A'}}</div>
                    <div class="log-field-label">Error Trace</div>
                </div>
            </div>

            <!-- Extra Data -->
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="log-field-block border-bottom-solid">
                    <div class="log-field-content log-field-mono">{{appLogDetails?.extra_data ?? 'N/A'}}</div>
                    <div class="log-field-label">Extra Data</div>
                </div>
            </div>

            <!-- Request Body -->
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="log-field-block border-bottom-solid">
                    <div class="log-field-content log-field-mono">{{appLogDetails?.request_body ?? 'N/A'}}</div>
                    <div class="log-field-label">Request Body</div>
                </div>
            </div>

        </div>
    </mat-list>
</div>
<div mat-dialog-actions style="justify-content: right;">
    <button mat-flat-button type="button" color="warn" (click)="onCancel()">Close</button>
</div>